import React from "react";
import { Box, CircularProgress } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import NoteAdd from "@material-ui/icons/NoteAdd";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteIcon from "@material-ui/icons/Delete";
import CustomButton from "../../Button/CustomButton";

export type GalleryButtonIconType = "ADD" | "UPLOAD" | "DOWNLOAD" | "DELETE";

export interface GalleryButtonProps {
  icon?: GalleryButtonIconType;
  loading?: boolean;
  disabled?: boolean;
  text: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

function GalleryButton(props: GalleryButtonProps) {
  const { icon, onClick, text, loading, disabled } = props;

  return (
    <CustomButton
      text={text}
      disabled={disabled || loading}
      startIcon={
        loading ? (
          <Box width={22} paddingTop={0.25} marginRight={1}>
            <CircularProgress size={16} variant="indeterminate" style={{ color: "inherited" }} />
          </Box>
        ) : (
          icon && (
            <Box marginRight="10px">
              {icon === "ADD" && <AddIcon fontSize="small" />}
              {icon === "UPLOAD" && <NoteAdd fontSize="small" />}
              {icon === "DOWNLOAD" && <GetAppIcon fontSize="small" />}
              {icon === "DELETE" && <DeleteIcon fontSize="small" />}
            </Box>
          )
        )
      }
      onClick={onClick}
    />
  );
}

export default GalleryButton;
